__turbopack_context__.v({
  "footer": "ovWska_footer",
  "header": "ovWska_header",
  "linkCollection": "ovWska_linkCollection",
});
